import { useEffect, useState } from "react";
import { getCurrentUser } from "../utils/authService";
import api from "../api/api";

const usePayments = () => {
  const [payment, setPayment] = useState({});
  const [schoolFeesPayment, setSchoolFeesPayment] = useState([]);
  const [loading, setLoading] = useState(false);
  const user = getCurrentUser();

  useEffect(() => {
    const getPayments = async () => {
      if (!user) return;
      setLoading(true);
      try {
        const { data } = await api.get(`/payments/student-payments/`);
        console.log("Student Payment", data);
        setPayment(data?.results);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching payments:", error);
      } finally {
        setLoading(false);
      }
    };

    getPayments();
  }, []);

  return { payment, schoolFeesPayment, loading };
};

export default usePayments;
